export default "./assets/aad22c02842baa1a2d30d103fd30121c.png";